import React from 'react';

import { FeaturePatternTrussContainer } from '@paragon/contract-library';
import { calculateFeaturePatternContainer3DShapeWithCache } from '@paragon/layout';

import { useAppSelector } from '../../../components/hooks';
import { getAllBearingEnvelopesDictionary } from '../../../store/selectors/layoutDataSelectors';
import { getActiveFeaturePatternContainerMode } from '../../../store/selectors/layoutVisualOptionsSelectors';
import { LayoutPolygonStyle } from '../polygon-rendering/common/style';
import { LayoutPolygonCollection } from '../polygon-rendering/LayoutPolygonCollection';
import { FeaturePatternContainerEventHandlers } from './FeaturePatternContainerEventHandlers';

interface Props {
  style: LayoutPolygonStyle;
  container: FeaturePatternTrussContainer | Omit<FeaturePatternTrussContainer, 'guid'>;
}

export function FeaturePatternContainerVisual({ style, container }: Props) {
  const renderMode = useAppSelector(getActiveFeaturePatternContainerMode);
  const bearingEnvelopes = useAppSelector(getAllBearingEnvelopesDictionary); // needed for geometry

  const shape3D = calculateFeaturePatternContainer3DShapeWithCache(container, bearingEnvelopes);

  if (shape3D == null || renderMode === 'none') return null;

  return (
    <FeaturePatternContainerEventHandlers container={container}>
      <LayoutPolygonCollection polygons={shape3D.faces} mode={renderMode} style={style} />
    </FeaturePatternContainerEventHandlers>
  );
}
